<template>
<panel>
  <p slot="header">
    Dodaj wiadomość
  </p>
  <p slot="actions">
    <ui-button type="flat" icon="navigate_before" color="primary" @click="$router.push({name: 'admin.messages.dashboard'})">Wróć</ui-button>
  </p>
  <messages-form :item="item"></messages-form>
</panel>
</template>

<script>
import Messages from './../../services/Messages'

export default {
  data () {
    return {
      item: Messages.getBaseItem()
    }
  },
  mounted () {
  }
}

</script>


// WEBPACK FOOTER //
// Create.vue?217d1bee